

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { MinimumWageRateSetup } from "../../components/MinimumWageRateSetup/MinimumWageRateSetup";


export const MinimumWageRatePage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="MinimumWageRate"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Minimum Wage Rate", navigateTo: "/minimum-wage-rate" }
      ]}
      mainContents={<MinimumWageRateSetup />}
    />
  );
};
